export const SET_MY_LOT_INFO = 'SET_MY_LOT_INFO';
export const SET_LOT_SITUATION = 'SET_LOT_SITUATION';
export const SEND_RESPONSE_COUNTER_OFFER = 'sendResponseCounterOffer';
export const UPDATE_SALES_STATUS_ID = 'updateSaleStatusId';
export const FAST_TRACK_PAY = 'fastTrackPay';
